import type { AxiosResponse } from "axios";

/**
 * The response body, but only when the status says it really is the declared
 * payload type.
 *
 * The shared `apiAxios` instance resolves a 4xx rather than throwing, so an
 * error body — an entirely different shape — arrives typed as the success
 * type. Pass data through here so it reads as `undefined` instead of as a
 * value that satisfies a truthiness test and then fails on first field access.
 */
export function okResponseData<T>(
  data: T | undefined,
  response: AxiosResponse<T> | undefined,
): T | undefined {
  if (response === undefined) return undefined;
  return response.status >= 200 && response.status < 300 ? data : undefined;
}
